// Both SQL safe and lowercase (for glue database/table names)
export const getSafeUniNodeName = (uniName: string, nodeName: string) =>
  `${uniName}_${nodeName}`.replace(/-/g, '_').replace(/\./g, '_').toLowerCase()
